import React from 'react';
import JuceBuilder from '../../container/JuceBuilder/JuceBuilder';

function Body() {
  return (
    <div className="container">
      <JuceBuilder />
    </div>
  );
}

export default Body;
